/** Half a day, in milliseconds. */
const HALF_A_DAY_MS = 12 * 60 * 60 * 1000;

/**
 * The day a plan counter resets, written as a day and a month without the year
 * ("1er novembre", "November 1").
 *
 * The API sends the reset as an instant: the first minute of the day in the
 * brand's own timezone, which the dashboard does not know. Read as it is, that
 * instant falls on the previous evening for anyone west of the brand. Read half
 * a day later it names the same calendar day for every reader within twelve
 * hours of the brand, which is every reader a brand has.
 *
 * French writes the first of a month "1er", which `Intl` does not.
 */
export function formatResetDay(
  resetsAt: string | null | undefined,
  locale: string,
  { short = false }: { short?: boolean } = {}
): string | null {
  if (!resetsAt) return null;
  const instant = new Date(resetsAt).getTime();
  if (Number.isNaN(instant)) return null;

  const written = new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: short ? 'short' : 'long',
  }).format(new Date(instant + HALF_A_DAY_MS));

  return locale.startsWith('fr') ? written.replace(/^1 /, '1er ') : written;
}
